/* Copyright(c) 2019 APSS Media Pvt. Ltd.
 *  All Rights Reserved
 */

/*
@author:Sanobar Golandaj
@Creation Date:12-09-2019
@Description:UI for (Dashboard) campaign specification
*/

import React, { Component } from "react";
import Navigation from "../layouts/navPage";
import Footer from "../layouts/footer";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../login/authentication";
import { withRouter } from "react-router-dom";
import CampaignSpecificationDashboardDetails from "./campaignSpecificationDashboardDetails";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { Badge } from "antd";//Kiran Dhainje 5958- import badge for showing count of notes on notes icon
import { fetch_custom as fetch } from "../../configration/fetch_default_headers";//snehal-task-3766-specification VAPT default header call
import "./campaignSpecificationDashboard.css"; //Mufiz-Bug-4243-R-28.8-Prod Issue-Agency-Campaign specification not opening -Shows blank page
//var greeting = "";//Rutuja 2978 commented this as never used
class CampaignDashboard extends Component {
	constructor() {
		super();
		this.state = {
			campID: "",
			parentCampID: "",
			reallocationID: "",

			agencyID: "",
			step: 2, //snehal-task-2935  assign value for step to display on URL
			button: false,
			// status:'',
			rfpID: "",
			Status: "",
			incompleteCampaignDetails: [],
			tabkey: "",
			campaignStatus: "", //kiran-4538-added campaignStatus variable
			showNotesModal: false,//Kiran Dhainje 5958-added state for showNotesModal
			campaignNotes: "",//Kiran Dhainje 5958-added state for campaignNotes
			campaignNotesHistory: [],//Kiran Dhainje 5958-added state for campaignNotesHistory
			editingNoteId: null,//Kiran Dhainje 5958-added state for editingNoteId
			editingNoteText: "",//Kiran Dhainje 5958-added state for editingNoteText
		};
		this.handleBackButtonToDashboard =
			this.handleBackButtonToDashboard.bind(this);
		this.handleFileDownload = this.handleFileDownload.bind(this);
		this.handleFileShowDownload = this.handleFileShowDownload.bind(this);
		this.handlePDFFileShowDownload = this.handlePDFFileShowDownload.bind(this);
		this.goToEditCampaign = this.goToEditCampaign.bind(this);
		this.goTocreateCampaign = this.goTocreateCampaign.bind(this); //shivani-task 3121-bind this goTocreateCampaign fun here.
			this.openNotesModal = this.openNotesModal.bind(this);//Kiran Dhainje 5958-added this function to open notes modal and below models
		this.closeNotesModal = this.closeNotesModal.bind(this);
		this.getCampaignNotes = this.getCampaignNotes.bind(this);
		this.handleNotesChange = this.handleNotesChange.bind(this);
		this.handleSendNotes = this.handleSendNotes.bind(this);
		this.handleDeleteNote = this.handleDeleteNote.bind(this);
		this.handleEditNote = this.handleEditNote.bind(this);
		this.handleEditNoteSave = this.handleEditNoteSave.bind(this);
		this.notesPanelRef = React.createRef();
		this.notesBodyRef = React.createRef();
	}

	componentDidMount() {
		if (!this.props.auth.isAuthenticated) {
			this.props.history.push("/userLogin");
		} else {
			// karan-task-3715-replace query params
			var campID, tabkey, parentCampID;
			if (this.props.location.state !== undefined) {
				 campID = this.props.location.state.campID;
				 tabkey = this.props.location.state.tabkey;
				 parentCampID = this.props.location.state.parentCampID;
			} else if (sessionStorage.getItem("campID") !== undefined) {
				 campID = sessionStorage.getItem("campID");
				 tabkey = sessionStorage.getItem("tabkey");
				 parentCampID = sessionStorage.getItem("parentCampID");
			} else {
				if (sessionStorage.getItem("parentCampID") === undefined) {
					sessionStorage.clear();
				}
			}
			const {  user } = this.props.auth; //Rutuja 2978  Removed isAuthenticated as never used
			var agencyID = user.id;
			this.setState({ agencyID: agencyID, parentCampID: parentCampID, tabkey});
			
			fetch("campaign/CampaignDetails?campID=" + campID)
				.then((res) => res.json())
				.then((campaignDetails) => {
					this.getCampaignNotes();//Kiran-5958-fetch campaign notes after getting campaign details to get the latest notes count for badge
					//this.state.campaignName = campaignDetails[0].campaignName;
					this.setState({campaignName: campaignDetails[0].campaignName}); //Rutuja - 2978 commented Above and used this.setState
					//shivani-task 3121-added conditions to hide download button for incomplete flow.
					var Status = campaignDetails[0].status;
					var campaignStatus = campaignDetails[0].campaignStatus;
					var button = this.state.button;
					if (
						Status === "BasicDetails" ||
						Status === "DeliveryOption" ||
						Status === "CampaignSpecification" ||
						Status === "XlsStep1" ||
						Status === "Step1" ||
						Status === "SupportingDocument" || // added this for bug - 3355
						Status === "undefined" ||
						Status === "null" ||
						Status === undefined ||
						Status === null
					) {
						button = false;
					} else {
						button = true;
					}
					this.setState({
						Status: Status,
						button,
						campaignStatus:campaignStatus, //kiran-4538-set state campaignStatus
						rfpID: campaignDetails[0].rfpProposalID,
					});
				})
				.catch(function (err) {
					console.log(err);
				});
		}
	} // end of Didmount
//Kiran-5958-Added helper methods for internal campaign notes
	computeInitials = (text = "") => {
	  if (!text) return "";
	  return text
		.split(/\s+/)
		.filter(Boolean)
		.slice(0, 2)
		.map((segment) => segment.charAt(0).toUpperCase())
		.join("");
	};

	getUserDisplayDetails = () => {
	  const authUser = (this.props.auth && this.props.auth.user) || {};
	  const nameFromProfile = [authUser.firstName, authUser.lastName]
		.filter(Boolean)
		.join(" ")
		.trim();
	  const fallbackName = authUser.userName || authUser.email || "Internal User";
	  const displayName = nameFromProfile || fallbackName || "Internal User";
	  return {
		name: displayName,
		initials: this.computeInitials(displayName),
	  };
	};

	resolveNoteUserMeta = (note) => {
	  const fallbackMeta = this.getUserDisplayDetails();
	  if (!note) return fallbackMeta;
	  const senderFullName = note.sender_full_name && note.sender_full_name.trim();
	  const senderName = senderFullName || note.sender_name || note.userName || note.createdBy || note.ownerName;
	  const sanitizedName = senderName && senderName.trim() ? senderName.trim() : fallbackMeta.name;
	  const initials = note.userInitials || note.sender_initials || this.computeInitials(sanitizedName);
	  return { name: sanitizedName, initials };
	};

	formatTimestamp = (value) => {
	  const date = value instanceof Date ? value : new Date(value);
	  if (Number.isNaN(date.getTime())) return "Invalid Date";
	  const diff = Date.now() - date.getTime();
	  if (diff < 60000) return "Just now";
	  if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`;
	  const today = new Date();
	  if (date.toDateString() === today.toDateString()) return date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
	  return date.toLocaleString("en-US", {
		month: "short",
		day: "2-digit",
		hour: "numeric",
		minute: "2-digit",
	  });
	};

	getTimestampLabel = (note) => {
	  if (!note) return "";
	  const rawTimestamp = note.updated_at || note.created_at || note.timestampISO || note.timestamp || note.createdAt || note.date;
	  if (!rawTimestamp) return "";
	  const formatted = this.formatTimestamp(rawTimestamp);
	  if (note.Edited_attempt > 0) return `Edited ${formatted}`;
	  return formatted;
	};

	getTimestampTitle = (note) => {
	  if (!note) return "";
	  const rawTimestamp = note.updated_at || note.created_at || note.timestampISO || note.timestamp || note.createdAt || note.date;
	  if (!rawTimestamp) return "";
	  const date = new Date(rawTimestamp);
	  if (Number.isNaN(date.getTime())) return "";
	  return date.toLocaleString("en-US", {
		month: "short",
		day: "2-digit",
		year: "numeric",
		hour: "numeric",
		minute: "2-digit",
	  });
	};

	//Kiran-5958-Added below code for internal campaign notes
	openNotesModal = () => {
	  if (!this.state.campID || String(this.state.campID).trim() === "") {
		alert("Campaign ID is not available.");
		return;
	  }

	  const isOpening = !this.state.showNotesModal;
	  this.setState(
		(prevState) => ({
		  showNotesModal: !prevState.showNotesModal,
		}),
		() => {
		  if (isOpening) {
			this.getCampaignNotes();
		  }
		}
	  );
	};

	closeNotesModal = () => {
	  this.setState({ showNotesModal: false });
	};

	getCampaignNotes = async () => {
	  const campID = String(this.state.campID).trim();
	  if (!campID) return;
	  try {
		const response = await fetch("publisher/campaignInternalNotes", {
		  method: "POST",
		  headers: { "Content-Type": "application/json" },
		  body: JSON.stringify({ action: "fetch", campaign_id: campID }),
		});
		const data = await response.json();
		console.log("Notes response:", data);
		if (data.success) {
		  this.setState({ campaignNotesHistory: data.result || [] });
		}
	  } catch (err) {
		console.error("Error fetching notes:", err);
	  }
	};

	handleNotesChange = (event) => {
	  this.setState({ campaignNotes: event.target.value });
	};

	handleSendNotes = async () => {
	  const { campaignNotes, campID } = this.state;
	  if (!campaignNotes.trim()) return;
	  try {
		const response = await fetch("publisher/campaignInternalNotes", {
		  method: "POST",
		  headers: { "Content-Type": "application/json" },
		  body: JSON.stringify({ action: "add", campaign_id: campID, notes: campaignNotes }),
		});
		const result = await response.json();
		if (result.success) {
		  this.setState({ campaignNotes: "" });
		  this.getCampaignNotes();
		}
	  } catch (err) {
		console.error("Error sending notes:", err);
	  }
	};

	handleEditNote = (noteId, noteMessage = "") => {
	  this.setState({ editingNoteId: noteId, editingNoteText: noteMessage });
	};

	handleEditNoteSave = async (noteId) => {
	  const { editingNoteText, campID } = this.state;
	  if (!editingNoteText.trim()) return;
	  try {
		const response = await fetch("publisher/campaignInternalNotes", {
		  method: "POST",
		  headers: { "Content-Type": "application/json" },
		  body: JSON.stringify({ action: "edit", note_id: noteId, campaign_id: campID, notes: editingNoteText }),
		});
		const result = await response.json();
		if (result.success) {
		  this.setState({ editingNoteId: null, editingNoteText: "" });
		  this.getCampaignNotes();
		}
	  } catch (err) {
		console.error("Error editing note:", err);
	  }
	};

	handleDeleteNote = async (noteId) => {
	  const { campID } = this.state;
	  try {
		const response = await fetch("publisher/campaignInternalNotes", {
		  method: "POST",
		  headers: { "Content-Type": "application/json" },
		  body: JSON.stringify({ action: "delete", note_id: noteId, campaign_id: campID }),
		});
		const result = await response.json();
		if (result.success) {
		  this.getCampaignNotes();
		}
	  } catch (err) {
		console.error("Error deleting note:", err);
	  }
	};

	handleBackButtonToDashboard(e) {
		e.preventDefault();//Rutuja 2978-added to remove #
		//shivani-task 3121-added this condition for , if user go from incomplete then user should back on the same page after clicking on back button.
        //Nilesh-4920- add user
		const { user } = this.props.auth
		if (this.state.button === false) {
			window.location.href = "/incompleteCampaignTab";
		}
		//Nilesh-4920- add else if condition for ANC
		else if(user.role === "ANC"){
             this.props.history.push("/newdashboard")
		}
		else 
		{
				this.props.history.push("/campaignList", {
				agencyID: this.state.agencyID,});
			
			//karan-task-3684-replace query params
		}
	}

	handleFileDownload(e) {
		var campID = this.state.campID;
		//var parentCampID = this.state.parentCampID; //Rutuja 2978  commented as never used
		/**
		 * @author Narendra Phadke
		 * @param  Description handle the Campaign related Files
		 * @return Description return All The File Download in Zip
		 */
		console.warn("campID===>" + campID);

		var formData = new FormData();
		formData.append("campID", campID);
		//const { isAuthenticated, user } = this.props.auth; //Rutuja 2978  Removed isAuthenticated as never used
		//var userID = user.id; //Rutuja 2978  commented as never used

		//This api is used for dynamic pdf genration
		fetch(
			"agency/downloadDynamicPDFCampaignDetailsforAgency?campID=" +
				campID +
				"&campName=" +
				this.state.campaignName 
		)
			.then((r) => r.blob())
			.then((downloadFiles) => this.setState({ downloadFiles: downloadFiles }))
			.then(this.handlePDFFileShowDownload);

		fetch(
			"agency/downloadCampaignDetailsforAgency?campID=" +
				campID +
				"&campName=" +
				encodeURIComponent(this.state.campaignName) //Rutuja task 5636 passing campaign name by doing ecodeURI
		)
			.then((r) => r.blob())
			.then((downloadFiles) => this.setState({ downloadFiles: downloadFiles }))
			.then(this.handleFileShowDownload);
	} /** End of handle File Download */

	handleFileShowDownload(blob) {
		// It is necessary to create a new blob object with mime-type explicitly set
		// otherwise only Chrome works like it should
		let zipFileDownloadName =
			this.state.campID + "-" + this.state.campaignName + ".zip"; //Rutuja task 5539 changed parentCampID to campID 

		var newBlob = new Blob([this.state.downloadFiles], {
			type: "application/zip",
		});
		// IE doesn't allow using a blob object directly as link href
		// instead it is necessary to use msSaveOrOpenBlob
		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveOrOpenBlob(newBlob);
			return;
		}

		// For other browsers:
		// Create a link pointing to the ObjectURL containing the blob.
		const data = window.URL.createObjectURL(newBlob);
		var link = document.createElement("a");
		link.href = data;
		link.download = zipFileDownloadName;
		link.click();

		// ));
	}

	handlePDFFileShowDownload(blob) {
		// It is necessary to create a new blob object with mime-type explicitly set
		// otherwise only Chrome works like it should
		let zipFileDownloadName =
			this.state.campID +  //Rutuja task 5539 changed parentCampID to campID 
			"-" +
			this.state.campaignName +
			"-CampaignSpecification.pdf";
		var newBlob = new Blob([this.state.downloadFiles], {
			type: "application/pdf",
		});
		// IE doesn't allow using a blob object directly as link href
		// instead it is necessary to use msSaveOrOpenBlob
		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveOrOpenBlob(newBlob);
			return;
		}

		// For other browsers:
		// Create a link pointing to the ObjectURL containing the blob.
		const data = window.URL.createObjectURL(newBlob);
		var link = document.createElement("a");
		link.href = data;
		link.download = zipFileDownloadName;
		link.click();

		// ));
	}
	/**
	 * @author Snehal more
	 * @param  Description goToEditCampaign function related to edit campaign direct from camp specification page
	 * @return Description go to edit campaign directly
	 */
	 goToEditCampaign(e) {
		// karan-task-3715-replace query params
		var campID, parentCampID, rfpCampaignID;
		if (this.props.location.state !== undefined) {
			campID = this.props.location.state.campID;
			parentCampID = this.props.location.state.parentCampID;
			rfpCampaignID = this.props.location.state.rfpCampaignID;
		}
		var edit = 1;
		if (rfpCampaignID) {
			if (rfpCampaignID === 0) {
				this.props.history.push("/welcomeEdit", {
					campID,
					parentCampID,
					step: this.state.step,
					edit,
				}); // karan-task-3714-vapt header and query params
			} else {
				this.props.history.push("/welcomeEdit", {
					campID,
					parentCampID,
					rfpCampaignID,
					step: this.state.step,
					edit,
				}); // karan-task-3714-vapt header and query params
			}
		} else {
			// window.location.href = '/welcomePage?campID='+campID+'&parentCampID='+parentCampID;
			this.props.history.push("/welcomeEdit", {
				campID,
				parentCampID,
				step: this.state.step,
				edit,
			}); // karan-task-3714-vapt header and query params
		}
	} //end of function goToEditCampaign



	/**
	 * @author Shivani pathak
	 * task- 3121
	 * @param  Description goTocreateCampaign function related to continue campaign direct from camp specification page
	 * @return Description go to create campaign directly after clicked on continue button.
	 */
	 goTocreateCampaign(e) {
		var campID = e.target.id;
		var status = e.target.getAttribute("status");
		var rfpID = e.target.getAttribute("rfpID");
		var reallocationId = e.target.getAttribute("reallocationId");
		var parentCampID = e.target.getAttribute("parentCampID");

		if (Number(rfpID) === 0) { //rutuja 2978 added numver and chnaged == to ===
			rfpID = "";
		}
		if (rfpID) {
			this.props.history.push("/createcampaign2", {
				campID,
				parentcampID: parentCampID,
				reallocationID: reallocationId,
				rfpCampaignID: rfpID,
				status,
			}); // karan-task-3767-replace query params

			// User Story 3125 : Karan Jagtap : added 1 more status="SupportingDocument"
			if (status === "Step1" || status === "SupportingDocument") { //Rutuja 2978 changed == to ===
				window.location.href =
					// "/step2supportingdocument?campID=" +
					// campID +
					// "&rfpCampaign&rfpCampaignID=" +
					// rfpID +
					// "&status=" +
					// status +
					// "&parentcampID=" +
					// parentCampID +
					// "&reallocationID=" +
					// reallocationId;
					this.props.history.push("/step2supportingdocument", {
						campID,
						rfpCampaignID: rfpID,
						status,
						parentcampID: parentCampID,
						reallocationID: reallocationId,
						rfpCampaign: "",
					}); // karan-task-3719-vapt header and query params
			}
		} else {
			this.props.history.push("/createcampaign2", {
				campID,
				parentcampID: parentCampID,
				reallocationID: reallocationId,
				status,
			}); // karan-task-3767-replace query params
			// User Story 3125 : Karan Jagtap : added 1 more status="SupportingDocument"
			if (status === "Step1" || status === "SupportingDocument") { //Rutuja 2978 changed == to ===
				// window.location.href =
				// 	"/step2supportingdocument?campID=" +
				// 	campID +
				// 	"&parentcampID=" +
				// 	parentCampID +
				// 	"&reallocationID=" +
				// 	reallocationId +
				// 	"&status=" +
				// 	status;
				this.props.history.push("/step2supportingdocument", {
					campID,
					parentcampID: parentCampID,
					reallocationID: reallocationId,
					status,
				}); // karan-task-3719-vapt header and query params
			}
		}
	} //end of function goTocreateCampaign
	render() {
		// karan-task-3715-replace query params
		if (this.props.location.state !== undefined) {
			this.state.campID = this.props.location.state.campID;
			this.state.parentCampID = this.props.location.state.parentCampID;
			this.state.reallocationID = this.props.location.state.reallocationID;
		} else if (sessionStorage.getItem("campID") !== undefined) {
			this.state.campID = sessionStorage.getItem("campID"); 
			this.state.parentCampID = sessionStorage.getItem("parentCampID");
			this.state.reallocationID = sessionStorage.getItem("reallocationID"); 
		}
		const {  user } = this.props.auth; //Rutuja 2978  removed isAuthenticated as never used
		const canViewNotes = user.role === "ANC" || user.role === "AQA" || user.role === "AC";//Kiran-5958-Added condition to show notes icon only for ANC, AQA and AC roles
		//const status = this.state.Status; //Rutuja 2978  commented as never used
		const campaignStatus = this.state.campaignStatus; //kiran-4538-assign campaignStatus
		return (
			<div>
				<Navigation />
				{/* Nilesh-4839 Add display, flexDirection,flex, backgroundColor, paddingTop, position, top and zIndex in below div */}
				<div class="CampSpecDashBord" style={{ paddingTop: "110px", display: "flex", flexDirection: "column"}}>
					<div class="container-fluid fixed-top" style={{
						flex: "0 0 auto",
						backgroundColor:"rgb(245 245 245)",
						paddingTop: "10px",
						position: "sticky",
						top: "79px",
						zIndex: "999"
					}}>
						<div className="row align-items-center" style={{ paddingBottom: "20px" }}>
                         {/* Kiran Dhainje 6001 Adjusted the Alignment  */}
						{/* LEFT */}
						<div className="col-lg-2 col-md-4 col-sm-6">
							<a href="#/">
							<FaArrowAltCircleLeft
								size={32}
								style={{ color: "#056eb8" }}
								title="Back to Dashboard"
								onClick={this.handleBackButtonToDashboard}
							/>
							</a>
						</div>

						{/* CENTER */}
						<div className="col-lg-6 col-md-8 col-sm-12 text-center">
							<label
							id="idOfCampSpecDash"
							style={{
								color: "#193D8F",
								fontSize: "28px",
								fontWeight: "500",
								fontFamily: "roboto",
							}}
							>
							Campaign ID: {this.state.campID}
							</label>
						</div>

						{/* RIGHT (ALL BUTTONS + ICON) */}
						<div className="col-lg-4 col-md-12 col-sm-12 d-flex justify-content-end align-items-center flex-wrap gap-2">

							{/* Notes Icon */}
							<Badge
							count={
								this.state.campaignNotesHistory.length > 10
								? "10+"
								: this.state.campaignNotesHistory.length
							}
							overflowCount={10}
							offset={[-3, -8]}
							>
							<img
								src="/notes.png"
								alt="Notes"
								title="View Internal Campaign Notes"
								style={{ width: "28px", height: "32px", cursor: "pointer",marginRight:"5px",marginBottom:"27px" }}
								onClick={this.openNotesModal}
							/>
							</Badge>

							{/* Download */}
							{this.state.button === true && (
							<button
								type="button"
								style={{ marginRight: "12px" }}
								className="btn add-button"
								id="campaignSpecDownloadBtn"
								onClick={this.handleFileDownload}
							>
								Download
							</button>
							)}

							{/* Edit */}
							{this.state.button === true &&
							campaignStatus !== "Live_Incomplete" &&
							campaignStatus !== "Paused" &&
							campaignStatus !== "Cancel Campaign" &&
							campaignStatus !== "Completed" && (
								<button
								id="editBtnInCSD"
								className="btn add-button"
								style={{ marginRight: "39px" }}
								disabled={
									user.role === "AQA" ||
									Number(this.state.tabkey) === 2 ||
									Number(this.state.tabkey) === 1
								}
								onClick={this.goToEditCampaign}
								>
								Edit Campaign
								</button>
							)}

							{/* Continue */}
							{this.state.button !== true && (
							<button
								className="btn add-button"
								onClick={this.goTocreateCampaign}
							>
								Continue
							</button>
							)}

						</div>
						</div>
					</div>

					{/* <div>  */}
					<CampaignSpecificationDashboardDetails
						greeting={this.state.campID}
						parentCampID={this.state.parentCampID}
					/>
					{/* </div> */}

					<div class="container-fluid" style={{ paddingBottom: "70px" }}>
						<div class="row">
							{/* <div class="col-lg-4"></div>
                   <div class="col-lg-3"><label></label></div> */}
							{this.state.button === true ? (
								<div class="col-lg-5" style={{ paddingTop: "20px" }}>
									<button

										type="button"
										class="btn add-button"
										id="campaignSpecDownloadBtnButton"
										style={{ float: "left" }}
										onClick={this.handleFileDownload}>
										Download
									</button>
								</div>
							) : (
								""
							)}
						</div>
					</div>
				</div>
				  {/* Kiran-5958-Added internal notes modal */}
                       {this.state.showNotesModal && (
              <div ref={this.notesPanelRef} className="internal-notes-wrapper">
                <div className="internal-notes-panel">
                  <button
                    type="button"
                    className="internal-notes-close"
                    onClick={this.closeNotesModal}
                    aria-label="Close internal campaign notes"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <div className="internal-notes-title">
                    <div className="internal-notes-heading">
                      Internal Campaign Notes
                    </div>
                    <div className="internal-notes-subtitle">
                      Campaign ID : <span>{this.state.campID || "--"}</span>
                    </div>
                  </div>
                  <div className="internal-notes-body" ref={this.notesBodyRef}>
                    {this.state.campaignNotesHistory.length > 0 ? (
                      this.state.campaignNotesHistory
                        .slice()
                        .reverse()
                        .map((note) => {
                          const { name, initials } = this.resolveNoteUserMeta(note);
                          const timestampLabel = this.getTimestampLabel(note);
                          const timestampTitle = this.getTimestampTitle(note);
                          const isJustNow = timestampLabel === "Just now";
                          const isEdited = note.Edited_attempt > 0;
                          return (
                            <div className="internal-note-item" key={note.note_id || note.id || note.created_at}>
                              <div className="internal-note-avatar">{initials}</div>
                              <div className="internal-note-content">
                                <div className="internal-note-header">
                                  <div className="internal-note-meta">
                                    <span className="internal-note-user">{name}</span>
                                    <span
                                      className={`internal-note-time ${isJustNow ? "internal-note-time-new" : ""} ${isEdited ? "internal-note-time-edited" : ""}`}
                                      title={timestampTitle}
                                    >
                                      {timestampLabel}
                                      {isEdited }
                                    </span>
                                  </div>
                                </div>
                                <div className="internal-note-message">{note.message}</div>
                              </div>
                            </div>
                          );
                        })
                    ) : (
                      <div className="internal-notes-empty">
                        <p>No notes yet.</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
				<Footer />
			</div>
		);
	}
}

/**
 * @author Narendra Phadke
 * @param  Description handle the login authentication
 * @return Description return All details of authentication
 */
CampaignDashboard.propTypes = {
	logoutUser: PropTypes.func.isRequired,
	auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
	auth: state.auth,
});
export default connect(mapStateToProps, { logoutUser })(
	withRouter(CampaignDashboard)
);
